// extracted by mini-css-extract-plugin
module.exports = {"csTeamSearchPage":"App_csTeamSearchPage__2TRSh","csTeamSearchContent":"App_csTeamSearchContent__33QXQ"};